import {observable, action, computed} from 'mobx';
import autobind from 'autobind-decorator';
import {clientOnly} from 'spa/utils';

class GeolocationState {
  @observable isLoading = false;
  @observable position = null;
  @observable error = null;
  @observable isSupported = true;

  promise = null;

  @action maybeLoad() {
    if (!this.position) {
      return this.load();
    }
    return this.promise;
  }
  @clientOnly
  @autobind
  @action
  load() {
    if (this.isLoading) return this.promise;
    this.isLoading = true;
    this.error = null;

    const GMaps = require('gmaps'); // eslint-disable-line global-require

    this.promise = new Promise((resolve, reject) =>
      GMaps.geolocate({
        not_supported: () => { this.onNotSupported(); reject(); },
        success: resolve,
        // Add some visible delay as errors are reported instantly
        error: (...args) => setTimeout(reject, 500, ...args),
      }));

    return this.promise
      .then(this.onSuccess, this.onError);
  }
  @autobind @action onSuccess(position) {
    this.isLoading = false;
    this.position = position;
    return position;
  }
  @autobind @action onError(error) {
    this.isLoading = false;
    this.error = error;
  }
  @autobind @action onNotSupported() {
    this.isSupported = false;
  }

  @computed get place_id() {
    const {position} = this;
    if (!position) {
      return null;
    }
    return `latlng:${position.coords.latitude},${position.coords.longitude}`;
  }

  @computed get isUserDenied() {
    return this.error && this.error.message === 'User denied Geolocation';
  }
}

const state = new GeolocationState();

export default state;



// WEBPACK FOOTER //
// ./spa/state/geolocation.jsx